document.addEventListener('DOMContentLoaded', async () => {
  const grid = document.getElementById('AllBlogsGrid');
  const paginationContainer = document.getElementById('AllBlogsPagination');
  const config = window.allBlogsConfig;

  if (!grid || !config.blogHandles.length) {
    if (grid) grid.innerHTML = '<p class="center">Please configure blog handles in the section settings.</p>';
    return;
  }

  let allArticles = [];
  let currentPage = 1;

  // Helper to fetch articles from a blog
  // We use a search query or just fetch the blog page JSON if available.
  // Since Shopify doesn't have a simple "get all articles" endpoint for storefront without API,
  // we will use the ?view=json trick on the blog pages.
  // We assume the user has a 'json' template or we can parse the HTML.
  // ACTUALLY, parsing HTML is safer if we don't want to create a json template for every blog.
  // BUT, creating a generic search query is better.
  // Let's try fetching the blog feed via Atom/RSS or just parsing the main blog page?
  // No, that only gives paginated results.

  // BETTER APPROACH:
  // We will fetch the first X pages of each blog until we run out.
  // This might be slow if there are 1000s, but user said "100+".

  async function fetchArticlesFromBlog(handle) {
    let page = 1;
    let blogArticles = [];
    let hasMore = true;

    while (hasMore) {
      try {
        // We'll fetch the blog page and parse it. 
        // To make this reliable, we should probably rely on a specific view.
        // But for now, let's try to fetch the standard page and look for article cards.
        // OR, we can use the Ajax API /recommendations/products? but that's for products.

        // Let's use the ?view=ajax approach. We need to create a snippet/template for this.
        // But I can't easily create a template for *every* blog handle without user doing it.
        // Wait, I can create `templates/blog.ajax.json` and then fetch `/blogs/handle?view=ajax`.
        // Yes, that's the robust way.

        const response = await fetch(`/blogs/${handle}?view=ajax&page=${page}`);
        if (!response.ok) break;

        const data = await response.json();
        if (data.articles && data.articles.length > 0) {
          blogArticles = blogArticles.concat(data.articles);
          // If we got fewer than limit (default 6 or whatever the ajax view returns), we are done.
          // We'll assume the ajax view returns a good chunk, say 50.
          if (data.articles.length < 50) hasMore = false;
          else page++;
        } else {
          hasMore = false;
        }

        // Safety break for now
        if (page > 5) hasMore = false;
      } catch (e) {
        console.error(`Error fetching blog ${handle}:`, e);
        hasMore = false;
      }
    }
    return blogArticles;
  }

  // We need to create the `blog.ajax.json` template first.
  // But wait, I can't create a file that automatically applies to all blogs unless I name it `blog.ajax.liquid` (or json).
  // Yes, `templates/blog.ajax.liquid` will work for `/blogs/any-handle?view=ajax`.

  async function init() {
    try {
      const promises = config.blogHandles.map(handle => fetchArticlesFromBlog(handle));
      const results = await Promise.all(promises);
      allArticles = results.flat().sort((a, b) => new Date(b.published_at) - new Date(a.published_at));

      renderPage(1);
    } catch (e) {
      console.error("Error initializing blogs:", e);
      grid.innerHTML = '<p class="center">Error loading articles. Please try again later.</p>';
    }
  }

  function renderPage(page) {
    currentPage = page;
    const start = (page - 1) * config.itemsPerPage;
    const end = start + config.itemsPerPage;
    const pageArticles = allArticles.slice(start, end);

    grid.innerHTML = pageArticles.map(article => buildArticleCard(article)).join('');

    renderPagination();

    // Scroll to top of section
    const section = document.getElementById('AllBlogsSection');
    if (section && page > 1) section.scrollIntoView({ behavior: 'smooth' });
  }

  // Helper function to format date properly
  function formatDate(dateString) {
    if (!dateString) return '';

    try {
      const date = new Date(dateString);

      // Check if date is valid
      if (isNaN(date.getTime())) {
        console.warn('Invalid date:', dateString);
        return '';
      }

      // Format date similar to Shopify's time_tag format
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };

      return date.toLocaleDateString('en-US', options);
    } catch (e) {
      console.error('Error formatting date:', e, dateString);
      return '';
    }
  }

  function buildArticleCard(article) {
    // This HTML should match your `article-card` snippet structure roughly
    // We can't use the liquid snippet directly in JS, so we recreate the markup.

    let imageHtml = '';
    if (config.showImage && article.image) {
      imageHtml = `
        <div class="article-card__image-wrapper card__media-wrapper">
          <div class="article-card__image media media--hover-effect" style="padding-bottom: 66.6%;">
            <img
              src="${article.image}"
              alt="${article.title}"
              loading="lazy"
              width="720"
              height="480"
              class="motion-reduce"
            >
          </div>
        </div>
      `;
    }

    let dateHtml = '';
    if (config.showDate && article.published_at) {
      const formattedDate = formatDate(article.published_at);
      if (formattedDate) {
        dateHtml = `<span class="circle-divider caption-with-letter-spacing">${formattedDate}</span>`;
      }
    }

    let authorHtml = '';
    if (config.showAuthor) {
      authorHtml = `<span class="caption-with-letter-spacing">${article.author}</span>`;
    }

    return `
      <div class="blog-articles__article article">
        <div class="card article-card card--standard card--media" style="--ratio-percent: 66.6%;">
          <div class="card__inner color-scheme-1 gradient ratio" style="--ratio-percent: 66.6%;">
            ${imageHtml}
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h2">
                  <a href="${article.url}" class="full-unstyled-link">
                    ${article.title}
                  </a>
                </h3>
              </div>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading h2">
                <a href="${article.url}" class="full-unstyled-link">
                  ${article.title}
                </a>
              </h3>
              <div class="article-card__info caption-with-letter-spacing h5">
                ${dateHtml}
                ${authorHtml}
              </div>
              <p class="article-card__excerpt rte-width">
                ${article.excerpt || ''}
              </p>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function renderPagination() {
    const totalPages = Math.ceil(allArticles.length / config.itemsPerPage);
    if (totalPages <= 1) {
      paginationContainer.innerHTML = '';
      return;
    }

    let html = '';

    // Prev
    html += `<button onclick="window.changeAllBlogsPage(${currentPage - 1})" ${currentPage === 1 ? 'disabled' : ''}>&larr;</button>`;

    // Numbers
    html += `<div class="page-numbers">`;
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - 1 && i <= currentPage + 1)) {
        html += `<div class="page-number ${i === currentPage ? 'active' : ''}" onclick="window.changeAllBlogsPage(${i})">${i}</div>`;
      } else if (i === currentPage - 2 || i === currentPage + 2) {
        html += `<span class="pagination__item">...</span>`;
      }
    }
    html += `</div>`;

    // Next
    html += `<button onclick="window.changeAllBlogsPage(${currentPage + 1})" ${currentPage === totalPages ? 'disabled' : ''}>&rarr;</button>`;

    paginationContainer.innerHTML = html;
  }

  window.changeAllBlogsPage = (page) => {
    if (page < 1 || page > Math.ceil(allArticles.length / config.itemsPerPage)) return;
    renderPage(page);
  };

  init();
});
